import type { JSX } from 'react';

import { Divider } from '../Divider/Divider';
import { Stack } from '../Stack/Stack';

type Props = {
  children: JSX.Element[];
  bullets?: boolean;
  spacing?: '.5rem' | '1rem' | '1.5rem' | '2rem';
  dividers?: boolean;
  width?: 'fit-content' | '100%';
};

export const List = ({
  children,
  bullets = false,
  spacing,
  dividers = false,
  width = 'fit-content',
}: Props) => {
  return (
    <ul
      style={{
        listStyleType: bullets ? 'disc' : 'none',
        padding: 0,
        paddingLeft: bullets ? 30 : 0,
        margin: 0,
        width,
      }}
    >
      {children.map((child, index) => (
        <li
          key={child.key}
          style={{
            display: bullets ? 'list-item' : 'block',
            marginBottom: !dividers && index !== children.length - 1 ? spacing : undefined,
          }}
        >
          {child}

          {dividers && index !== children.length - 1 && (
            <Stack my=".5rem">
              <Divider />
            </Stack>
          )}
        </li>
      ))}
    </ul>
  );
};
